module.exports = __webpack_public_path__ + "img/services_web_apps.bf986c7b.png";